import { motion } from "framer-motion";
import React from "react";
import { formatTime } from "../../utils/formatTime";

interface PlayerProgressProps {
  progress: number;
  duration: number;
  isDragging: boolean;
  dragProgress: number | null;
  onSeekStart: (e: React.MouseEvent | React.TouchEvent) => void;
  onSeek: (e: React.MouseEvent | React.TouchEvent) => void;
  onSeekEnd: (e: React.MouseEvent | React.TouchEvent) => void;
  mini?: boolean;
}

export const PlayerProgress: React.FC<PlayerProgressProps> = ({
  progress,
  duration,
  isDragging,
  dragProgress,
  onSeekStart,
  onSeek,
  onSeekEnd,
  mini,
}) => {
  const displayProgress = dragProgress ?? progress;

  return (
    <div className={mini ? "" : "mb-8"}>
      <div
        className={`relative w-full touch-none group ${mini ? "h-0" : "h-16"}`}
        onMouseDown={onSeekStart}
        onMouseMove={isDragging ? onSeek : undefined}
        onMouseUp={onSeekEnd}
        onMouseLeave={onSeekEnd}
        onTouchStart={onSeekStart}
        onTouchMove={isDragging ? onSeek : undefined}
        onTouchEnd={onSeekEnd}
      >
        <div
          className={`absolute top-1/2 -translate-y-1/2 w-full h-1 bg-zinc-800 rounded-full ${
            mini ? "group-hover:h-1.5" : "group-hover:h-2"
          } transition-all`}
        >
          <motion.div
            className="absolute h-full bg-yellow-500 rounded-full"
            style={{ width: `${displayProgress}%` }}
            layoutId="progress"
          />
          <div
            className={`absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white rounded-full transform -translate-x-1/2 transition-all ${
              isDragging ? "opacity-100 scale-110" : "opacity-0 group-hover:opacity-100"
            }`}
            style={{ left: `${displayProgress}%` }}
          />
        </div>
      </div>
      {!mini && (
        <div className="flex justify-between px-1 md:px-4 text-sm text-zinc-400">
          <span>{formatTime((displayProgress / 100) * duration)}</span>
          <span>{formatTime(duration)}</span>
        </div>
      )}
    </div>
  );
};
